function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { Autocomplete, Button, InputAdornment, LinearProgress, NumericInput, Modal, SectionSpacer, Typography } from '@applyboard/ui-components';
import { UserContext, verifyRole } from '@applyboard/ui-utils';
import { SearchOutlineIcon } from '@applyboard/ui-icons';
import { debounce } from 'lodash';
import useGradeSchemes from "./useGradeSchemes";
import { apiMinGrade, apiEducationLevels } from "./grades";
import { useCountries } from '@applyboard/business-ui-legacy';
import { StatusMessage } from "./StatusMessage";
var DEBOUNCE_TIME_MS = 400;
function MagnifyingGlassAdornment() {
  return /*#__PURE__*/React.createElement(InputAdornment, {
    position: "start"
  }, /*#__PURE__*/React.createElement(SearchOutlineIcon, {
    "aria-label": "education-country-select-icon"
  }));
}
var OTHER_GRADE_SCALE_OPTIONS = [{
  label: '4',
  value: '4'
}, {
  label: '5',
  value: '5'
}, {
  label: '7',
  value: '7'
}, {
  label: '10',
  value: '10'
}, {
  label: '20',
  value: '20'
}, {
  label: '100',
  value: '100'
}];
var NO_SELECTION = {
  label: '',
  value: ''
};
export function GradeEligibilityModal(_ref) {
  var programId = _ref.programId,
    minGpa = _ref.minGpa,
    open = _ref.open,
    onClose = _ref.onClose,
    _ref$performDebounce = _ref.performDebounce,
    performDebounce = _ref$performDebounce === void 0 ? true : _ref$performDebounce,
    _ref$autoSelectOption = _ref.autoSelectOptions,
    autoSelectOptions = _ref$autoSelectOption === void 0 ? false : _ref$autoSelectOption,
    _ref$autoHighlightFir = _ref.autoHighlightFirstOption,
    autoHighlightFirstOption = _ref$autoHighlightFir === void 0 ? false : _ref$autoHighlightFir;
  var user = useContext(UserContext);
  var displayPersonalizedMessage = verifyRole.isVisitor(user) || verifyRole.isStudent(user);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    educationLevels = _useState2[0],
    setEducationLevels = _useState2[1];
  var _useState3 = useState(NO_SELECTION),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedCountry = _useState4[0],
    setSelectedCountry = _useState4[1];
  var _useState5 = useState(NO_SELECTION),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedEducationLevel = _useState6[0],
    setSelectedEducationLevel = _useState6[1];
  var _useState7 = useState(NO_SELECTION),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedGradingScheme = _useState8[0],
    setSelectedGradingScheme = _useState8[1];
  var _useState9 = useState(NO_SELECTION),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedGradeAverage = _useState10[0],
    setSelectedGradeAverage = _useState10[1];
  var _useState11 = useState(NO_SELECTION),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedGradingScale = _useState12[0],
    setSelectedGradingScale = _useState12[1];
  var _useState13 = useState({
      meets_minimum: null,
      min_required_convert_from_score: null,
      min_required_convert_from_letter_name: null
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    gradeConversionResults = _useState14[0],
    setGradeConversionResults = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isLoading = _useState16[0],
    setIsLoading = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    errorMessage = _useState18[0],
    setErrorMessage = _useState18[1];
  var _useCountries = useCountries(),
    countries = _useCountries.countries;
  var countriesList = useMemo(function () {
    return countries.map(function (item) {
      return {
        label: item.name,
        value: item.code
      };
    });
  }, [countries.length]);
  useEffect(function () {
    apiEducationLevels().then(function (response) {
      if (!response.data || !Array.isArray(response.data)) {
        setEducationLevels([]);
      } else {
        setEducationLevels(response.data.map(function (item) {
          return {
            label: item.name,
            value: item.id
          };
        }));
      }
    });
  }, []);
  var selectedLetterGrades = selectedGradingScheme.letter_grades;
  var letterGradeOptions = useMemo(function () {
    if (!selectedLetterGrades) {
      return null;
    }
    return selectedLetterGrades.map(function (grade) {
      return {
        label: grade.name,
        value: grade.name
      };
    });
  }, [selectedLetterGrades]);
  var _useGradeSchemes = useGradeSchemes(selectedCountry.value, selectedEducationLevel.value, true),
    _useGradeSchemes2 = _slicedToArray(_useGradeSchemes, 1),
    gradeSchemeList = _useGradeSchemes2[0];
  useEffect(function () {
    setSelectedGradingScheme(NO_SELECTION);
    setSelectedGradeAverage(NO_SELECTION);
  }, [selectedCountry, selectedEducationLevel]);
  var resetStatusMessage = useCallback(function () {
    setGradeConversionResults({
      meets_minimum: null,
      min_required_convert_from_score: null,
      min_required_convert_from_letter_name: null
    });
    setErrorMessage(null);
  }, []);
  useEffect(function () {
    resetStatusMessage();
  }, [selectedCountry, selectedEducationLevel, selectedGradeAverage, selectedGradingScale, selectedGradingScheme]);
  var gradeSchemeOptions = useMemo(function () {
    return gradeSchemeList.map(function (_ref2) {
      var id = _ref2.id,
        name = _ref2.name,
        type = _ref2.type,
        min = _ref2.min,
        max = _ref2.max,
        letter_grades = _ref2.letter_grades;
      return {
        label: name,
        value: id,
        type: type,
        min: min,
        max: max,
        letter_grades: letter_grades
      };
    }).concat({
      label: 'Other',
      value: 0,
      type: 'other',
      min: undefined,
      max: undefined,
      letter_grades: undefined
    });
  }, [gradeSchemeList, selectedCountry, selectedEducationLevel]);
  var clearState = function clearState() {
    setSelectedCountry(NO_SELECTION);
    setSelectedEducationLevel(NO_SELECTION);
    setSelectedGradingScheme(NO_SELECTION);
    setSelectedGradeAverage(NO_SELECTION);
    setSelectedGradingScale(NO_SELECTION);
    setErrorMessage(null);
  };
  var callAPINumber = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
      var _response$data, _response$data$min_re, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            setErrorMessage(null);
            _context.prev = 2;
            _context.next = 5;
            return apiMinGrade(params);
          case 5:
            response = _context.sent;
            setGradeConversionResults(_objectSpread(_objectSpread({}, response.data), {}, {
              min_required_convert_from_score: (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$min_re = _response$data.min_required_convert_from_score) === null || _response$data$min_re === void 0 ? void 0 : _response$data$min_re.toFixed(2)
            }));
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            setErrorMessage('There was an error processing this request.');
          case 12:
            setIsLoading(false);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function callAPINumber(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var callAPILetter = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsLoading(true);
            setErrorMessage(null);
            _context2.prev = 2;
            _context2.next = 5;
            return apiMinGrade(params);
          case 5:
            response = _context2.sent;
            setGradeConversionResults(response.data);
            _context2.next = 12;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            setErrorMessage('There was an error processing this request.');
          case 12:
            setIsLoading(false);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 9]]);
    }));
    return function callAPILetter(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    // prevent API call until grading scheme and grading average are provided
    if (selectedGradingScheme === undefined || selectedGradingScheme === null || selectedGradingScheme.value === '') {
      return;
    }
    if (selectedGradeAverage === undefined || selectedGradeAverage === null || selectedGradeAverage.value === '') {
      return;
    }
    if (selectedGradingScheme.type === 'other') {
      if (selectedGradingScale.value !== '') {
        var studentAverage = Number(selectedGradeAverage.value) / Number(selectedGradingScale.value) * 100;
        setGradeConversionResults({
          meets_minimum: studentAverage >= Number(minGpa),
          min_required_convert_from_score: "".concat(minGpa, "%")
        });
      }
      // call min_acceptable_score API and store result in state
    } else if (selectedGradingScheme.type === 'numerical') {
      callAPINumber({
        scheme_id: selectedGradingScheme.value.toString(),
        program_id: programId,
        grade: selectedGradeAverage.value
      });
    } else if (selectedGradingScheme.type === 'letter') {
      callAPILetter({
        scheme_id: selectedGradingScheme.value.toString(),
        program_id: programId,
        grade: selectedGradeAverage.value
      });
    } else {
      throw new Error("Selected grading scheme has a wrong type: ".concat(selectedGradingScheme.type));
    }
  }, [selectedGradeAverage, selectedGradingScheme]);
  var onDismiss = useCallback(function () {
    clearState();
    onClose();
  }, [clearState, onClose]);
  var getOptionLabel = useCallback(function (option) {
    return option.label;
  }, []);
  var FooterComponent = useCallback(function () {
    return /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      onClick: onDismiss,
      variant: "outlined"
    }, "Dismiss");
  }, [onDismiss]);
  var onNumericalGradeAverageChanged = useCallback(function (average) {
    return setSelectedGradeAverage({
      value: average,
      label: average
    });
  }, [setSelectedGradeAverage]);
  var onEducationCountryChanged = useCallback(function (_, option) {
    return setSelectedCountry(option || NO_SELECTION);
  }, [setSelectedEducationLevel]);
  var onEducationLevelChanged = useCallback(function (_, option) {
    return setSelectedEducationLevel(option || NO_SELECTION);
  }, [setSelectedEducationLevel]);
  var onGradingSchemeChanged = useCallback(function (_, option) {
    setSelectedGradeAverage(NO_SELECTION);
    setSelectedGradingScheme(option || NO_SELECTION);
  }, [setSelectedGradeAverage, setSelectedGradingScheme]);
  var onGradingScaleChanged = useCallback(function (_, option) {
    return setSelectedGradingScale(option || NO_SELECTION);
  }, [setSelectedGradingScale]);
  var onLetterGradingAverageChanged = useCallback(function (_, option) {
    return setSelectedGradeAverage(option || NO_SELECTION);
  }, [setSelectedGradeAverage]);
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    handleClose: onDismiss,
    title: "Check Grade Eligibility",
    footerButtons: FooterComponent
  }, /*#__PURE__*/React.createElement(SectionSpacer, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "This program requires a minimum GPA of ", minGpa, "% to apply. To calculate eligibility please select ", displayPersonalizedMessage ? 'your' : "the applicant's", " local grading scheme and average."), /*#__PURE__*/React.createElement(Autocomplete, {
    label: "Education country",
    placeholder: "Education country",
    value: selectedCountry.label ? selectedCountry : null,
    disabled: isLoading,
    options: countriesList,
    getOptionLabel: getOptionLabel,
    autoComplete: true,
    autoHighlight: autoHighlightFirstOption,
    autoSelect: autoSelectOptions,
    freeSolo: false,
    onChange: onEducationCountryChanged,
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(MagnifyingGlassAdornment, null)
    }
  }), /*#__PURE__*/React.createElement(Autocomplete, {
    label: "Education level",
    placeholder: "Education level",
    value: selectedEducationLevel.label ? selectedEducationLevel : null,
    disabled: isLoading,
    options: educationLevels,
    getOptionLabel: getOptionLabel,
    autoComplete: true,
    autoHighlight: autoHighlightFirstOption,
    autoSelect: autoSelectOptions,
    freeSolo: false,
    onChange: onEducationLevelChanged
  }), /*#__PURE__*/React.createElement(Autocomplete, {
    label: "Grading scheme",
    placeholder: "Grading scheme",
    value: selectedGradingScheme.label ? selectedGradingScheme : null,
    disabled: isLoading,
    options: gradeSchemeOptions,
    getOptionLabel: getOptionLabel,
    autoComplete: true,
    autoHighlight: autoHighlightFirstOption,
    autoSelect: autoSelectOptions,
    freeSolo: false,
    onChange: onGradingSchemeChanged
  }), selectedGradingScheme.type === 'other' && /*#__PURE__*/React.createElement(Autocomplete, {
    label: "Grading scale",
    placeholder: "Grading scale",
    value: selectedGradingScale.label ? selectedGradingScale : null,
    disabled: isLoading,
    options: OTHER_GRADE_SCALE_OPTIONS,
    getOptionLabel: getOptionLabel,
    autoComplete: true,
    autoHighlight: autoHighlightFirstOption,
    autoSelect: autoSelectOptions,
    freeSolo: false,
    onChange: onGradingScaleChanged
  }), selectedGradingScheme.type === 'letter' && /*#__PURE__*/React.createElement(Autocomplete, {
    label: "Grading average",
    placeholder: "Grading average",
    value: selectedGradeAverage.label ? selectedGradeAverage : null,
    disabled: isLoading,
    options: letterGradeOptions,
    getOptionLabel: getOptionLabel,
    autoComplete: true,
    autoHighlight: autoHighlightFirstOption,
    autoSelect: autoSelectOptions,
    freeSolo: false,
    onChange: onLetterGradingAverageChanged
  }), selectedGradingScheme.type === 'numerical' && /*#__PURE__*/React.createElement(NumericInput, {
    label: "Grading average",
    disabled: isLoading,
    min: selectedGradingScheme.min,
    max: selectedGradingScheme.max,
    onChange: performDebounce ? debounce(onNumericalGradeAverageChanged, DEBOUNCE_TIME_MS) : onNumericalGradeAverageChanged
  }), selectedGradingScheme.type === 'other' && selectedGradingScale.value !== '' && /*#__PURE__*/React.createElement(NumericInput, {
    label: "Grading average",
    disabled: isLoading,
    min: 0,
    max: Number(selectedGradingScale.value),
    onChange: performDebounce ? debounce(onNumericalGradeAverageChanged, DEBOUNCE_TIME_MS) : onNumericalGradeAverageChanged
  }), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, null) : /*#__PURE__*/React.createElement(StatusMessage, {
    gradeConversionResults: gradeConversionResults,
    errorMessage: errorMessage
  })));
}